import type { OrderDetail } from '../types';

import styles from './order-detail.module.scss';
import { OrderMetaRow } from './order-meta-row';

export function LogisticsCard({ logistics }: { logistics: OrderDetail['logistics'] }) {
  return (
    <section className={styles.card}>
      <h2 className={styles.cardTitle}>Logistics</h2>
      <dl className={styles.metaList}>
        <OrderMetaRow label="City" value={logistics.city} />
        <OrderMetaRow label="Billing Address" value={logistics.billingAddress} />
        <OrderMetaRow label="Shipping Address" value={logistics.shippingAddress} />
      </dl>
    </section>
  );
}
